/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface IlsControllerRemoveContentFromIls$Params {
  ilsId: string;
  contentId: string;
}

export function ilsControllerRemoveContentFromIls(http: HttpClient, rootUrl: string, params: IlsControllerRemoveContentFromIls$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerRemoveContentFromIls.PATH, 'delete');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('contentId', params.contentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ilsControllerRemoveContentFromIls.PATH = '/ils/{ilsId}/content/{contentId}';
